import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewRfiComponent } from './new-rfi.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxAutocompleteModule, DxTextAreaModule, DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxTextBoxModule, DxHtmlEditorModule, DxTooltipModule } from 'devextreme-angular';
import { NewContactModule } from 'src/app/shared/new-contact/new-contact.module';



@NgModule({
  declarations: [NewRfiComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxDateBoxModule, 
    DxAutocompleteModule,
    DxTextAreaModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxHtmlEditorModule,
    DxTooltipModule,
    NewContactModule
  ],
  exports: [
    NewRfiComponent
  ]
})
export class NewRfiModule { }
